import { connect } from 'react-redux'
import FileUI from './FileUI'
import { Dispatch } from 'redux';
import FileState from '../../State/FileState';
import FileDispatch from './model';
import ApplicationState from '../../../../../../../ApplicationState';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import { ActionType } from '../../Actions/ActionTypes';

const mapStateToProps = (state: ApplicationState): IState<FileState> => {
    return {
        state: state.file
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<FileDispatch> => ({
    dispatcher: {
        close: () => {
            dispatch({
                type: ActionType.FILE_SHOW,
                data: undefined
            })
        },
        saved: () => {
            dispatch({
                type: ActionType.FILE_SAVE
            })
        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(FileUI)